<template>
  <div>
    <navbar :links="['dashboard', $route.name]" />
    <div
      v-if="!$user || loading"
      class="loading-indicator"
    >
      <v-progress-circular
        :size="50"
        indeterminate
        class="mt-5 msr--text"
      />
    </div>
    <span v-else>
      <!-- Info and a button to request setup for usermanagement. -->
      <v-layout
        v-if="!$store.getters.userCanSeeUserManagementMenuOption"
        class="mt-5"
      >
        <!-- If the email is too generic, just show a warning. -->
        <generic-email-warning-with-button
          v-if="$userprofile && $userprofile.is_email_domain_generic"
        />
        <!-- Otherwise a hint and button to request the usermanagement feature. -->
        <request-feature-hint v-else />
      </v-layout>
      <div v-else>
        <!-- Router buttons that look like tabs -->
        <v-layout
          class="mt-3"
          :justify-center="$vuetify.breakpoint.xs"
        >
          <v-btn
            v-if="$store.getters.isUsermanagerOrManagedCoadmin"
            flat
            class="black--text ml-0"
            style="opacity: 0.65"
            to="/users/invite"
            :block="$vuetify.breakpoint.xs"
          >{{
            $vuetify.breakpoint.xsOnly
              ? $t('userManagementInviteNewShort')
              : $t('userManagementInviteNew')
          }}</v-btn>
          <v-btn
            flat
            class="black--text ml-0"
            style="border-bottom: 2px solid var(--msr-color-primary)"
            :block="$vuetify.breakpoint.xs"
          >
            <v-badge
              color="msr"
              class="nudged-right"
            >
              <span
                v-if="managedUsers.length > 0"
                slot="badge"
                :style="{
                  'font-size': managedUsers.length > 9 ? '13px' : '14px',
                }"
              >{{ managedUsers.length + 1 }}</span>
              {{
                $vuetify.breakpoint.xsOnly
                  ? manageUsersTabTitleShort
                  : manageUsersTabTitle
              }}
            </v-badge>
          </v-btn>
        </v-layout>
        <manage-users class="mt-3" />
      </div>
    </span>
  </div>
</template>

<script>
import commonUsermanagement from '@/mixins/commonUsermanagement.js';

import GenericEmailWarningWithButton from '@/components/GenericEmailWarningWithButton';
import ManageUsers from '@/components/UserManagement/ManageUsers';
import Navbar from '@/components/Navbar';
import RequestFeatureHint from '@/components/UserManagement/RequestFeatureHint';

export default {
  components: {
    GenericEmailWarningWithButton,
    ManageUsers,
    Navbar,
    RequestFeatureHint,
  },
  mixins: [commonUsermanagement],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.fetchUserDataAsNeeded();
  },
};
</script>

<style scoped>
.nudged-right >>> .v-badge__badge {
  right: -26px;
}
</style>



// WEBPACK FOOTER //
// src/pages/UserManagementManage.vue